/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type SocialRegister200Status = typeof SocialRegister200Status[keyof typeof SocialRegister200Status];


export const SocialRegister200Status = {
  ALREADY_REGISTERED: 'ALREADY_REGISTERED',
  REGISTRATION_INCOMPLETE: 'REGISTRATION_INCOMPLETE',
} as const;
